import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

type ViewHistoryType = {
  logs: any;
};
const ViewHistory: React.FC<ViewHistoryType> = (props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        width: '100%',
        height: '100%',
      }}
    >
      <Table
        sx={{
          minWidth: 500,
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            p: '6px 16px',
            fontSize: '14px',
          },
          '& .MuiTableCell-root.MuiTableCell-body': {
            color: 'primary.dark',
            fontSize: '14px',
            py: '6px',
          },
        }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            <TableCell>No</TableCell>
            <TableCell>時間</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.logs && props.logs.map((log: any, index: number) => (
            <TableRow
              key={index}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
                  py: '16px',
                  borderBottom: '1px solid #F3F3F3',
                },
              }}
            >
              <TableCell>{log.no}</TableCell>
              <TableCell>{log.time}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ViewHistory;
